module.exports = __webpack_public_path__ + "static/media/lv_hero.ea5c9cc7.png";